import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PPIInvestmentProjectGrantFormComponent from "./form-component";
import * as actions from "../../../../../actions";
import PPIInvestmentProjectGrantService from "../../../../../service/sfp/ppi-investment-project-grant-service";
import GrantsService from "../../../../../service/sfp/grant-service";

class InvestmentProjectGrantFormContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: undefined,
      submitting: false,
      id: "",
      name: "",
    };
  }

  componentDidMount() {
    if (this.props.grant)
      this.setState({
        id: this.props.grant.id,
        name: this.props.grant.name,
      });
  }

  render() {
    return (
      <PPIInvestmentProjectGrantFormComponent
        grants={this.props.grants}
        delete={this.props.delete}
        toggle={this.props.toggle}
        id={this.state.id}
        name={this.state.name}
        onIdChange={(e) => {
          this.setState({ id: e.target.value });
        }}
        onNameChange={(e) => {
          e.constructor === String
            ? this.setState({ name: e })
            : this.setState({ name: e.target.value });
        }}
        grant={this.props.grant}
        onSubmit={this._handleSubmit}
        submitting={this.state.submitting}
      />
    );
  }

  _handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
    event.preventDefault();
    event.persist();
    this.setState({ submitting: true });

    const ppi_project_grant = {
      grant: event.target.id.value,
      awarded: this.props.awarded,
      project: this.props.project.id,
    };

    if (event.target.id.value == "-2") {
      this.setState({ dataToSave: ppi_project_grant }, () => {
        GrantsService.createGrant({
          name: event.target.name.value,
          localAuthority: this.props.currentLocalAuthority.id,
        }).then(
          this._resolveCreateGrant.bind(this, event),
          this._rejectCreateGrant
        );
      });
    } else {
      this._handleSave(ppi_project_grant, event);
    }
  };

  _handleSave(ppi_project_grant, event) {
    if (this.props.delete) {
      PPIInvestmentProjectGrantService.deletePPIInvestmentProjectGrant(
        this.props.grant
      ).then(
        this._resolveDeleteInvestmentProjectGrant.bind(this, event),
        this._rejectDeleteInvestmentProjectGrant
      );
    } else if (this.props.toggle) {
      PPIInvestmentProjectGrantService.updatePPIInvestmentProjectGrant(
        this.props.grant.id,
        { awarded: !this.props.grant.awarded }
      ).then(
        this._resolveUpdateInvestmentProjectGrant.bind(this, event),
        this._rejectUpdateInvestmentProjectGrant
      );
    } else if (this.props.grant) {
      PPIInvestmentProjectGrantService.updatePPIInvestmentProjectGrant(
        this.props.grant.id,
        ppi_project_grant
      ).then(
        this._resolveUpdateInvestmentProjectGrant.bind(this, event),
        this._rejectUpdateInvestmentProjectGrant
      );
    } else {
      PPIInvestmentProjectGrantService.createPPIInvestmentProjectGrant(
        ppi_project_grant
      ).then(
        this._resolveCreateInvestmentProjectGrant.bind(this, event),
        this._rejectCreateInvestmentProjectGrant
      );
    }
  }

  _rejectCreateGrant = (error) => {
    this.props.actions.throwError(error);
    this.setState({ error, submitting: false });
  };

  _resolveCreateGrant = (
    /** @type {React.SyntheticEvent<Element>} */ event,
    /** @type {Object} */ response
  ) => {
    var ppi_project_grant = this.state.dataToSave;
    ppi_project_grant["grant"] = response.id;
    this._handleSave(ppi_project_grant, event);
  };

  _rejectCreateInvestmentProjectGrant = (error) => {
    this.props.actions.throwError(error);
    this.setState({ error, submitting: false });
  };

  _resolveCreateInvestmentProjectGrant = (
    /** @type {React.SyntheticEvent<Element>} */ event,
    /** @type {Object} */ response
  ) => {
    event.target.reset();
    this.setState({ submitting: false }, () => {
      this.props.onCreated(response);
    });
  };

  _rejectUpdateInvestmentProjectGrant = (error) => {
    this.props.actions.throwError(error);
    this.setState({ error, submitting: false });
  };

  _resolveUpdateInvestmentProjectGrant = (
    /** @type {React.SyntheticEvent<Element>} */ event,
    /** @type {Object} */ response
  ) => {
    event.target.reset();
    this.setState({ submitting: false }, () => {
      this.props.onUpdated(response);
    });
  };

  _rejectDeleteInvestmentProjectGrant = (error) => {
    this.props.actions.throwError(error);
    this.setState({ error, submitting: false });
  };

  _resolveDeleteInvestmentProjectGrant = (
    /** @type {React.SyntheticEvent<Element>} */ event,
    /** @type {Object} */ response
  ) => {
    event.target.reset();
    this.setState({ submitting: false }, () => {
      this.props.onDeleted(response);
    });
  };
}

const mapStateToProps = (state) => ({
  currentLocalAuthority: state.currentLocalAuthority,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvestmentProjectGrantFormContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/form-container.js